import PropTypes from "prop-types";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { memo } from "react";

const LandingPageListingHeadMetadata = ({
	landingPageLabel,
	metaTitle = "page.title.default",
	metaDescription = "page.description.default",
}) => {
	return (
		<HeadMetadata
			description={metaDescription}
			title={metaTitle}
			titleAttributes={{
				label: landingPageLabel,
			}}
			robotsMetaTag="index, follow"
		/>
	);
};

LandingPageListingHeadMetadata.propTypes = {
	landingPageLabel: PropTypes.string,
	metaTitle: PropTypes.string,
	metaDescription: PropTypes.string,
};

export default memo(LandingPageListingHeadMetadata);
